import EventService from 'src/services/api/eventService';
import { age } from 'src/components/helpers';

export const normalizeReservationPhone = (phone) => {
  const value = String(phone ?? '');
  return value.substring(0, 2) === '57' ? value.substring(2, 15) : value;
};

export const buildAuditoriumInscriptionBody = ({
  inputs,
  identification,
  phone,
  eventSlugname,
  captcha,
  captchaRequired,
}) => {
  const lookupPhone = normalizeReservationPhone(phone);
  let body = {
    ...inputs,
    identification,
    phone: lookupPhone,
    eventSlugname,
    ...(captchaRequired ? { captcha } : {}),
  };

  if (String(eventSlugname || '').includes('eraciones')) {
    body = { ...body, doubleCheck: eventSlugname };
  }

  return { body, lookupPhone };
};

export const mergeAuditoriumInscriptionInfo = (data = {}, { identification, phone } = {}) => {
  let info = {};
  if (identification != null) info.identification = identification;
  if (phone != null) info.phone = phone;

  if (data.finded && data.guest) {
    info = { ...data.guest, ...info, age: age(data.guest.birthdate) };
  }
  if (data.allReservations) info = { allReservations: data.allReservations, ...info };
  if (data.groupLeader) info = { groupLeader: data.groupLeader, ...info };
  if (data.volunteer) info = { ...data.volunteer, ...info };
  if (data.reserved) {
    info = { ...data.reserved, ...info };
    if (data.seat) info = { selected: data.seat, ...info };
  }
  if (data.quarantine) {
    const { emergencyContact, emergencyNumber } = data.quarantine;
    info = { emergencyContact, emergencyNumber, ...info };
  }

  return info;
};

export const fetchAuditoriumInscription = async (params) => {
  const { body, lookupPhone } = buildAuditoriumInscriptionBody(params);
  const response = await EventService.CheckAuditoriumInscription(body);
  return { response, lookupPhone };
};
